import {
  ReactNode,
  createContext,
  useContext,
  useEffect,
  useState,
} from "react"
import usePathname from "./usePathname"

export enum Modals {
  SaveGame,
  ImportGames,
  AddEvent,
  EditEvent,
  DeleteEvent,
  AddPlayer,
  EditPlayer,
  DeletePlayer,
  Share,
  Help,
  PWA,
  EmbedGame,
  Promotion,
}

type ModalsContextType = {
  activeModal: Modals | null
  openModal: (modal: Modals) => void
  closeModal: () => void
}

const ModalsContext = createContext<ModalsContextType>({} as ModalsContextType)

export function ModalsProvider({ children }: { children: ReactNode }) {
  const [activeModal, setActiveModal] = useState<Modals | null>(null)
  const pathname = usePathname()

  const openModal = (modal: Modals) => setActiveModal(modal)
  const closeModal = () => setActiveModal(null)

  // Close modals on route change
  useEffect(() => {
    closeModal()
  }, [pathname])

  return (
    <ModalsContext.Provider
      value={{
        activeModal,
        openModal,
        closeModal,
      }}
    >
      {children}
    </ModalsContext.Provider>
  )
}

export function useModals() {
  const context = useContext(ModalsContext)
  if (context === undefined) {
    throw new Error("useModals must be used within a ModalsProvider")
  }
  return context
}
